export const DISPATCH_ITEM_LIST = 'DISPATCH_ITEM_LIST'
export const INSERT_DISPATCH_ITEM = 'INSERT_DISPATCH_ITEM'
export const CROSSING_CITY = 'CROSSING_CITY'
export const DEFAULT_CROSSING_CITY_BRANCH = 'DEFAULT_CROSSING_CITY_BRANCH'
export const CROSSING_BRANCH = 'CROSSING_BRANCH'
export const DESTINATION_BRANCH = 'DESTINATION_BRANCH'
export const DISPATCHED_LUGGAGE = 'DISPATCHED_LUGGAGE'
export const EDIT_DISPATCH = 'EDIT_DISPATCH'
export const UPDATE_DISPATCH = 'UPDATE_DISPATCH'
export const CANCEL_DISPATCH = 'CANCEL_DISPATCH'
export const CHECKIN_REPORT = 'CHECKIN_REPORT'
export const DISPATCH_MEMO = 'DISPATCH_MEMO'
export const GET_BUS_AND_CARGO_TRIP_MAPING='GET_BUS_AND_CARGO_TRIP_MAPING'
export const GET_BUS_MASTER_TYPE = 'GET_BUS_MASTER_TYPE'
export const DISPATCH_GLOBAL_STATE_RESET = 'DISPATCH_GLOBAL_STATE_RESET'
export const DESTCITY_WITH_CROSSING_BRANCH = 'DESTCITY_WITH_CROSSING_BRANCH'
